import React from 'react'
import CardCarousel from "../CardCarousel";

const Homeblock5 = () => {
    return (
        <div>
            <h1>Big Deals</h1>
            <CardCarousel/>
        </div>
    )
}

export default Homeblock5
